// Typed fetch wrappers for the Pages Functions API.
import type { HostEntry } from "./types";

const api = (path: string, init?: RequestInit) =>
  fetch(path, {
    ...init,
    headers: {
      "content-type": "application/json",
      ...(init?.headers ?? {}),
    },
  }).then(async (r) => {
    const text = await r.text();
    const data = text ? JSON.parse(text) : null;
    if (!r.ok) throw new Error(data?.error ?? `HTTP ${r.status}`);
    return data;
  });

export const apiHosts = (opts: { min?: number; healthy?: boolean } = {}) => {
  const p = new URLSearchParams();
  if (opts.min != null) p.set("min", String(opts.min));
  if (opts.healthy) p.set("healthy", "1");
  return api(`/api/hosts?${p.toString()}`) as Promise<HostEntry[]>;
};

export const apiBest = (n = 1) =>
  api(`/api/best?n=${n}`) as Promise<HostEntry | HostEntry[] | null>;

export const apiAdjust = (domain: string, delta: number) =>
  api(`/api/adjust`, {
    method: "POST",
    body: JSON.stringify({ domain, delta }),
  }) as Promise<HostEntry>;

export const apiReport = (domain: string, ok: boolean) =>
  api(`/api/report`, {
    method: "POST",
    body: JSON.stringify({ domain, ok }),
  }) as Promise<HostEntry>;

export const apiPoll = (opts: { sourceUrl?: string } = {}) =>
  api(`/api/poll`, { method: "POST", body: JSON.stringify(opts.sourceUrl ? { source_url: opts.sourceUrl } : {}) }) as Promise<{
    updated: number; source_last_update: string | null; source_used?: string | null;
  }>;
/** Info about the configured uptime-JSON feed. */
export const apiSource = () =>
  api(`/api/source`) as Promise<{
    url: string | null; host_count: number; last_update: string | null;
  }>;

export const apiFail = (domain: string) =>
  api(`/api/fail`, {
    method: "POST",
    body: JSON.stringify({ domain }),
  }) as Promise<{ ok: boolean; deduped?: boolean; effective?: number }>;
